var monaco = require('./src/Monaco.vue')

module.exports = monaco
